import { TouchEvent, useState } from 'react';

import { useTranslation } from '@crehana/i18n';
import { Col, Container, IconButton, Row } from '@crehana/ui';

import { ArrowIosLeft, ArrowIosRight } from '@crehana/icons/outline';

import { LEADERS } from './constants';
import LeaderCard from './LeaderCard';

import {
  CarouselContainer,
  CarouselItem,
  StyledSection,
} from './Leaders.styles';

const Leaders = () => {
  const { t } = useTranslation();
  const [centerItem, setCenterItem] = useState<1 | 2 | 3>(1);
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);

  // the required distance between touchStart and touchEnd to be detected as a swipe
  const minSwipeDistance = 50;

  const onTouchStart = (e: TouchEvent<HTMLDivElement>) => {
    setTouchEnd(null); // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e: TouchEvent<HTMLDivElement>) =>
    setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      handleNext();
    }

    if (isRightSwipe) {
      handlePrev();
    }
  };

  const handleNext = () => {
    if (centerItem === 3) {
      setCenterItem(1);
    } else {
      // @ts-expect-error - we expect an error because typescript thinks that it will be another number than 1 | 2 | 3,
      // but it never can happen for the if condition
      setCenterItem(centerItem + 1);
    }
  };

  const handlePrev = () => {
    if (centerItem === 1) {
      setCenterItem(3);
    } else {
      // @ts-expect-error - we expect an error because typescript thinks that it will be another number than 1 | 2 | 3,
      // but it never can happen for the if condition
      setCenterItem(centerItem - 1);
    }
  };

  return (
    <StyledSection className="pt-32 lg:pt-0 bg-gray-lighter relative overflow-hidden">
      <Container>
        <Row>
          <Col>
            <h2 className="font-h2 mb-52 text-center text-32 leading-40 lg:text-40">
              {t('LEADERS_TITLE')}
            </h2>
            <CarouselContainer
              className="relative z-3 flex w-full "
              active={centerItem}
            >
              {LEADERS.map((leader, i) => (
                <CarouselItem
                  onTouchStart={onTouchStart}
                  onTouchMove={onTouchMove}
                  onTouchEnd={onTouchEnd}
                  key={`leaders-section-${i}`}
                  className="absolute inset-0 m-auto"
                >
                  <LeaderCard {...leader} />
                </CarouselItem>
              ))}
            </CarouselContainer>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="flex flex-row items-center justify-center z-3 relative w-full mt-64 sm:mt-0">
              <IconButton
                withoutBorders
                className="mr-24"
                icon={{ component: ArrowIosLeft }}
                onClick={handlePrev}
                htmlProps={{ 'aria-label': 'Navigation previous item' }}
              />
              <span className="font-nun text-16">
                <strong>0{centerItem}</strong>{' '}
                <span className="mx-12"> / </span> 03
              </span>
              <IconButton
                withoutBorders
                className="ml-24"
                icon={{ component: ArrowIosRight }}
                onClick={handleNext}
                htmlProps={{ 'aria-label': 'Navigation next item' }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </StyledSection>
  );
};

export default Leaders;
